'use client'

import {ReactNode} from 'react'
import {usePlayButton} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context'
import s from './style.module.scss'

type Props = {
  children: ReactNode
  isMobile: boolean
}

const VisiblityProvider = ({children, isMobile}: Props) => {
  const {gameScreenShown} = usePlayButton()
  return (!gameScreenShown || !isMobile) && <div className={s.page_container}>{children}</div>
}

export default VisiblityProvider
